export const SMALL_CONTAINER_WIDTH = 420;
export const MEDIUM_CONTAINER_WIDTH = 640;
export const LARGE_CONTAINER_WIDTH = 850;
export const STANDARD_FILTER_WIDTH = 200;
